export function InvestIcon(props) {
    return (
        <svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M3.75 29.9998L15 18.7498L22.1767 25.9282C24.2512 21.8378 27.6739 18.5888 31.8667 16.7298L36.4333 14.6965M36.4333 14.6965L26.5333 10.8965M36.4333 14.6965L32.6333 24.5982" stroke="white" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
        </svg>
    )
}
